import { PlainItemsSelector } from 'app/common/ui-next/plain-selector'
import { BuildingId } from 'app/common/types/id'

import {
  filterActions,
  useFilterOptionsLoadingByKey,
  useFilterOptions,
  useFilter,
} from '../../filterStore'

import { sortByTitle, emptyArray } from './helpers'

export const BuildingControl = () => {
  const ids = useFilter('buildingIds')
  const buildings = useFilterOptions('buildings')
  const loading = useFilterOptionsLoadingByKey('buildings')

  return (
    <PlainItemsSelector
      id="building"
      label="Корпус"
      header="Выбор корпуса"
      pleaseSelectText="Все"
      items={buildings}
      selection={ids.draft || emptyArray}
      defaultSelection={ids.default || emptyArray}
      onChange={(selected) =>
        filterActions.selectDraftBuildingIds(selected as Array<BuildingId> | undefined)
      }
      loading={loading}
      sortFunc={sortByTitle}
      skipUpperSpace
      multiple
    />
  )
}
